import React from 'react';
import ComponentToggleButton from '../../../../components/component-toggle-button/component-toggle-button';
import classNames from 'classnames';
import T from 'i18n-react';

class gdprCookieSettingsSettingSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sectionOpen: false
    };
  }

  componentDidMount() {
  }

  toggleSectionClickedHandler = () => {
    //setTimeout(() => {
    //    $('.gdpr-cookie-settings-setting-section__info-container').animate({
    //      height: (this.state.sectionOpen ? 'hide' : 'show')
    //    }, 250);
    //}, 100);

    this.setState({sectionOpen:!this.state.sectionOpen});
  }

  toggleButtonClickedHandler = (checked) => {
    
  } 

  render() {
    let buttonElement;

    if (this.props.checkedStatus !== 2) {
      buttonElement = <ComponentToggleButton buttonTextChecked={this.props.GDPRCookieSettingsOnText} buttonTextNotChecked={this.props.GDPRCookieSettingsOffText} buttonChecked={(this.props.checkedStatus === 0 ? false : true)} buttonClickedHandler={this.props.toggleButtonClickedHandler} />
    }
    else {
      buttonElement = <span className="gdpr-cookie-settings-setting-section__heading-section__toggle-setting__text">{this.props.GDPRCookieSettingsAlwaysOnText}</span>
    }

    return (
      <div className={`gdpr-cookie-settings-setting-section ${(this.state.sectionOpen ? 'open' : '')}`} >
        <div className="gdpr-cookie-settings-setting-section__heading-section">
          <div className="gdpr-cookie-settings-setting-section__heading-section__toggle-setting">
            {buttonElement}
          </div>
          <button className="gdpr-cookie-settings-setting-section__heading-section__heading" aria-expanded={this.state.sectionOpen} aria-label={`Expanderbar, ${this.props.sectionHeading}`} onClick={this.toggleSectionClickedHandler}>
            <h3>
              {this.props.sectionHeading}
            </h3>
            <div className="gdpr-cookie-settings-setting-section__heading-section__toggle-info">
              <i className="icon icon-feather-chevron-right"></i>
            </div>
          </button>
        </div>
        <div dangerouslySetInnerHTML={{ __html: this.props.sectionInfoText }} className="gdpr-cookie-settings-setting-section__info-container">
        </div>
      </div>
    );
  }
}
export default gdprCookieSettingsSettingSection;
